import React from 'react'

const Statistics = () => {
  return (
    <div>
        {/* collapseFiftyNine */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingFiftyNine">
                <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFiftyNine" aria-expanded="false" aria-controls="collapseFiftyNine">
                    Statistics <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div id="collapseFiftyNine" className="accordion-collapse collapse" aria-labelledby="headingFiftyNine" data-bs-parent="#accordionCourses">
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <strong>Introduction to Data Science and Statistical Thinking</strong>
                    <ul>
                        <li>Role of statistics in data analysis and decision-making</li>
                        <li>Types of data and measurement scales</li>
                        <li>Central Tendency - Mean, median, mode, skewness</li>
                        <li>Standard Deviation & variance</li>
                        <li>Introduction to probability theory and basic concepts</li>
                    </ul>

                    <strong>Exploratory Data Analysis (EDA)</strong>
                    <ul>
                        <li>Understanding data distributions and summary statistics</li>
                        <li>Visualisation techniques for EDA (histograms, box plots, scatter plots)</li>
                        <li>Identifying outliers and missing values</li>
                        <li>Correlation analysis and heatmap visualization</li>
                        <li>Hands-on exercises with Python/R for EDA</li>
                    </ul>

                    <strong>Probability Distributions</strong>
                    <ul>
                        <li>Probability distributions (discrete and continuous)</li>
                        <li>Normal distribution and its properties</li>
                        <li>Binomial and Poisson distributions</li>
                        <li>Central Limit Theorem and its implications</li>
                        <li>Simulating random variables in Python/R</li>
                    </ul>

                    <strong>Statistical Inference</strong>
                    <ul>
                        <li>Point estimation and interval estimation</li>
                        <li>Hypothesis testing: concepts and methodologies</li>
                        <li>One-sample and two-sample tests</li>
                        <li>Chi-square tests for categorical data analysis</li>
                        <li>Hands-on practice with hypothesis testing using Python/R</li>
                    </ul>

                    <strong>Regression Analysis</strong>
                    <ul>
                        <li>Introduction to linear regression</li>
                        <li>Simple linear regression vs. multiple linear regression</li>
                        <li>Assumptions and diagnostics in regression analysis</li>
                        <li>Model evaluation metrics (R-squared, RMSE, MAE)</li>
                        <li>Practical implementation of regression models in Python/R</li>
                    </ul>

                    <strong>Classification Techniques</strong>
                    <ul>
                        <li>Overview of classification algorithms (logistic regression, decision trees, SVM)</li>
                        <li>Evaluation metrics for classification models (accuracy, precision, recall, F1-score)</li>
                        <li>Cross-validation techniques for model validation</li>
                        <li>Introduction to ensemble methods (bagging, boosting)</li>
                        <li>Hands-on exercises with classification algorithms in Python/R</li>
                    </ul>

                    <strong>Clustering and Dimensionality Reduction</strong>
                    <ul>
                        <li>Introduction to unsupervised learning</li>
                        <li>K-means clustering algorithm and its variants</li>
                        <li>Hierarchical clustering techniques</li>
                        <li>Dimensionality reduction methods (PCA, t-SNE)</li>
                        <li>Practical applications and implementation in Python/R</li>
                    </ul>

                    <strong>Time Series Analysis</strong>
                    <ul>
                        <li>Time series data: components and patterns</li>
                        <li>Decomposition methods (additive vs. multiplicative)</li>
                        <li>Forecasting techniques (ARIMA, exponential smoothing)</li>
                        <li>Model evaluation and performance metrics</li>
                        <li>Time series analysis with Python/R libraries</li>
                    </ul>

                    <strong>Bayesian Statistics</strong>
                    <ul>
                        <li>Bayesian reasoning and updating priors</li>
                        <li>Markov Chain Monte Carlo (MCMC) methods</li>
                        <li>Practical applications of Bayesian statistics in data science</li>
                        <li>Hands-on exercises with Bayesian analysis in Python/R</li>
                    </ul>

                    <strong>Hands-on Exercise</strong>
                    <ul>
                        <li>Integration of statistical and mathematical concepts into a data science project</li>
                        <li>Project presentation and peer review</li>
                        <li>Review of key concepts and methodologies covered in the course</li>
                        <li>Q&A and open discussion</li>
                    </ul>

                </div>
            </div>
        </div>

    </div>
  )
}

export default Statistics